const ID_TOKEN_KEY = 'id_token';
const FREEE_ACCESS_TOKEN_KEY = 'freee_access_token';
const FREEE_REFRESH_TOKEN_KEY = 'freee_refresh_token';

const GOOGLE_ACCESS_TOKEN_KEY = 'google_access_token';
const GOOGLE_REFRESH_TOKEN_KEY = 'google_refresh_token';

export function getFreeeAccessToken() {
  return sessionStorage.getItem(FREEE_ACCESS_TOKEN_KEY);
}
export function getFreeeRefreshToken() {
  return sessionStorage.getItem(FREEE_REFRESH_TOKEN_KEY);
}

export function getGoogleAccessToken() {
  return sessionStorage.getItem(GOOGLE_ACCESS_TOKEN_KEY);
}

export function getGoogleRefreshToken() {
  return sessionStorage.getItem(GOOGLE_REFRESH_TOKEN_KEY);
}

export function getIdToken() {
  return sessionStorage.getItem(ID_TOKEN_KEY);
}

export function setFreeeAccessToken(accessToken) {
  sessionStorage.setItem(FREEE_ACCESS_TOKEN_KEY, accessToken);
}

export function setFreeeRefreshToken(refreshToken) {
  sessionStorage.setItem(FREEE_REFRESH_TOKEN_KEY, refreshToken);
}

export function setGoogleAccessToken(accessToken) {
  sessionStorage.setItem(GOOGLE_ACCESS_TOKEN_KEY, accessToken);
}

export function setGoogleRefreshToken(refreshToken) {
  sessionStorage.setItem(GOOGLE_REFRESH_TOKEN_KEY, refreshToken);
}

export function setIdToken() {
  let idToken = getParameterByName(ID_TOKEN_KEY);
  sessionStorage.setItem(ID_TOKEN_KEY, idToken);
}

// access_token と id_token を展開することを許可するヘルパー関数
function getParameterByName(name) {
  let match = RegExp('[#&]' + name + '=([^&]*)').exec(window.location.hash);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

export function isFreeeLoggedIn() {
  const freeeToken = getFreeeRefreshToken();
  return !!freeeToken;
}

export function isGoogleLoggedIn() {
  const googleToken = getGoogleRefreshToken();
  return !!googleToken;
}

export function clearToken() {
  sessionStorage.clear()
}

export function getCodeFromSearchParam(param) {
  const params = new URLSearchParams(param);
  return params.get('code')
}